import bindEvent from '../../scripts/util/bindEvent';
import $ from 'jquery';

const selectors = {
	parent: '.js-team-card',
	target: '.js-team-card-open',
	content: '.js-team-card-content',
	images: '.team-card__type-image',
	imageWrap: '.team-card__image-wrap'
};

const classes = {
	active: 'team-card_state_active',
	contentActive: 'team-card__content_state_active',
	imageLoaded: 'team-card__type-image-loaded'
};

const clickHandler = e => {
	const el = e.currentTarget;
	const parent = el.closest(selectors.parent);
	const content = parent.querySelector(selectors.content);
	if (parent.classList.contains(classes.active)) {
		content.classList.remove(classes.contentActive);
		setTimeout(() => {
			parent.classList.remove(classes.active);
		}, 500);
	}
	else {
		content.classList.add(classes.contentActive);
		parent.classList.add(classes.active);
	}
};

const preloadImages = (images, callback) => {
	let counter = 0;
	let i;
	function onLoad() {
		counter++;
		if (counter === images.length) {
			callback();
		}
	}
	for (i = 0; i < images.length; i++) {
		const img = document.createElement('img');
		img.onload = img.onerror = onLoad;
		img.src = images[i].src;
		$(images[i]).closest(selectors.imageWrap).addClass(classes.imageLoaded);
	}
};

const imagesLoader = () => {
	preloadImages($(selectors.images), function () {});
};

const render = () => {
	bindEvent(selectors.target, 'click', clickHandler);
	imagesLoader();
};

export default render;

